"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="28px" height="32px" viewBox="0 0 28 32" enable-background="new 0 0 28 32" xml:space="preserve">
<g>
	<path fill="currentColor" d="M1.5,32h25c0.869,0,1.5-0.631,1.5-1.5v-28C28,1.631,27.369,1,26.5,1h-4C22.224,1,22,1.224,22,1.5
		S22.224,2,22.5,2h4C26.813,2,27,2.187,27,2.5v28c0,0.313-0.187,0.5-0.5,0.5h-25C1.187,31,1,30.813,1,30.5v-28
		C1,2.187,1.187,2,1.5,2h4C5.776,2,6,1.776,6,1.5S5.776,1,5.5,1h-4C0.631,1,0,1.631,0,2.5v28C0,31.369,0.631,32,1.5,32z"/>
	<path fill="currentColor" d="M5.5,5C5.776,5,6,4.776,6,4.5S5.776,4,5.5,4h-2C3.224,4,3,4.224,3,4.5v24C3,28.776,3.224,29,3.5,29h21
		c0.276,0,0.5-0.224,0.5-0.5v-24C25,4.224,24.776,4,24.5,4h-2C22.224,4,22,4.224,22,4.5S22.224,5,22.5,5H24v23H4V5H5.5z"/>
	<path fill="currentColor" d="M9,7h10c1.215,0,2-0.785,2-2V0.5C21,0.224,20.776,0,20.5,0h-13C7.224,0,7,0.224,7,0.5V5
		C7,6.215,7.785,7,9,7z M8,1h12v4c0,0.664-0.337,1-1,1H9C8.337,6,8,5.664,8,5V1z"/>
	<path fill="currentColor" d="M8.5,16h11c0.276,0,0.5-0.224,0.5-0.5S19.776,15,19.5,15h-11C8.224,15,8,15.224,8,15.5S8.224,16,8.5,16z"/>
	<path fill="currentColor" d="M8.5,12h11c0.276,0,0.5-0.224,0.5-0.5S19.776,11,19.5,11h-11C8.224,11,8,11.224,8,11.5S8.224,12,8.5,12z"/>
	<path fill="currentColor" d="M8.5,20h11c0.276,0,0.5-0.224,0.5-0.5S19.776,19,19.5,19h-11C8.224,19,8,19.224,8,19.5S8.224,20,8.5,20z"/>
	<path fill="currentColor" d="M8.5,24h11c0.276,0,0.5-0.224,0.5-0.5S19.776,23,19.5,23h-11C8.224,23,8,23.224,8,23.5S8.224,24,8.5,24z"/>
</g>
</svg>
`;
exports.default = icon;
